// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

export function isAdmin (userData) {
  if (userData && userData['custom:Role']) {
    return userData['custom:Role'] === 'TenantAdmin'
  }
  return false
}
